import React from 'react';
import '@/styles/modify-nickname.scss';
import { inject, observer } from 'mobx-react';
import * as antd from 'antd';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import useQuery from 'hooks/useQuery';

const ModifyNickname = props => {
  const { account: store } = props;
  let history = useHistory();
  const query = useQuery();

  /**
   * 初始化
   */
  useEffect(() => {
    store.nickname = query.nickname;
  }, []);

  async function doModify() {
    if (await store.doModifyNickname()) {
      antd.message.success('修改成功');
      history.goBack();
    }
  }

  return (
    <div className='modify-nickname'>
      <div className='header'>
        <div
          className='back'
          onClick={() => {
            history.go(-1);
          }}
        >
          <img
            src={require('@/images/modify-nickname/back.png')}
            alt=''
            className='arrow'
          />
        </div>
        <div className='title'>修改昵称</div>
      </div>

      <div className='form'>
        <div className='floor'>
          <input
            type='text'
            className='input'
            placeholder='输入昵称'
            value={store.nickname}
            onChange={e => {
              store.nickname = e.currentTarget.value;
            }}
          />
        </div>
        <div className='floor btn-floor'>
          <button className='submit-btn' onClick={doModify}>
            确认修改
          </button>
        </div>
      </div>
    </div>
  );
};

export default inject('account')(observer(ModifyNickname));
